import React, {FC, useMemo} from 'react';
import styles from './UtilizationWarning.module.scss';
import classNames from 'classnames';
import {UtilizationValue} from './types';
import {Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {texts} from '../../../texts';

export type UtilizationWarningProps = {
    value?: number;
    type: UtilizationValue;
};

export const UtilizationWarning: FC<UtilizationWarningProps> = ({value, type}) => {
    const warningText = useMemo(() => {
        switch (type) {
            case UtilizationValue.Warning:
                return texts.optimization_transactions_warning.replace(
                    '#',
                    Math.round((1 - value) * 100)
                );
            case UtilizationValue.ExceedsNumber:
                return texts.optimization_exceed_limit;
            case UtilizationValue.GracePeriod:
                return texts.optimization_grace_period;
        }

        return '';
    }, [type, value]);

    if (type === UtilizationValue.NoWarning) {
        return null;
    }

    return (
        <div
            className={classNames(styles.wrapper, {
                [styles.error]: [
                    UtilizationValue.ExceedsNumber,
                    UtilizationValue.GracePeriod
                ].includes(type),
                [styles.warning]: [UtilizationValue.Warning].includes(type)
            })}
        >
            <Icon icon={PriorityIcon.moreInfo} />
            <Text skin={'paragraph-1'} textColor={'primary-700'}>
                {warningText}
            </Text>
        </div>
    );
};
